<ul class="layout-tabmenu-nav">
    <li class="sidebar-group">
        <mat-button-toggle-group #ladderViewModeGroup="matButtonToggleGroup" (change)="onViewModeChange($event)"
            [vertical]="true">
            <mat-button-toggle class="dashboardOptionSidebar" value="EOD_SIGN_OFF"
                [checked]="viewMode == 'EOD_SIGN_OFF'" matTooltip="EOD Sign Off" matTooltipPosition="right">
                <mat-icon>verified</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle class="dashboardOptionSidebar" value="RECORD_MODIFICATION"
                [checked]="viewMode == 'RECORD_MODIFICATION'" matTooltip="Record Audit" matTooltipPosition="right">
                <mat-icon>preview</mat-icon>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </li>
</ul>